import styled from "@emotion/styled";
import {
  Grid,
  H1,
  H2,
  IconBarbell,
  IconClouds,
  IconHearts,
  IconMicrophone,
  IconTwitter,
  Img,
  FlexRow,
  Hr,
  Link,
  Text,
  Avatar,
  SiteContainer,
} from "atoms";
import { constants } from "config";
import { Head } from "features/misc";
import aboutUsSVG from "assets/images/about-us.svg";
import meetOurTeam from "assets/images/meet-our-team.png";
import welcomeInclusiverseSVG from "assets/images/welcome-to-the-inclusiverse.svg";
import randiHeadshot from "assets/images/randi-zuckerburg-headshot.jpg";
import randiAvatar1 from "assets/images/avatar_randi-1.png";
import randiAvatar2 from "assets/images/avatar_randi-2.png";
import randiAvatar3 from "assets/images/avatar_randi-3.png";
import debbieHeadshot from "assets/images/debbie-soon-headshot.jpg";
import debbieAvatar1 from "assets/images/avatar_debbie-1.png";
import debbieAvatar2 from "assets/images/avatar_debbie-2.png";
import debbieAvatar3 from "assets/images/avatar_debbie-3.png";
import loriHeadshot from "assets/images/lori-grace-headshot.jpg";
import hansHeadshot from "assets/images/dr-hans-boateng-headshot.jpg";
import chrisHeadshot from "assets/images/chris-kelly-headshot.jpg";

import amyHeadshot from "assets/images/amy-mcmillen-headshot-illo.png";
import brianHeadshot from "assets/images/brian-murphy-headshot-illo.png";
import davednoHeadshot from "assets/images/davedno-headshot-illo.png";
import juliaHeadshot from "assets/images/julia-gierasimow-headshot-illo.png";
import kenHeadshot from "assets/images/ken-richard-headshot-illo.png";
import lorrHeadshot from "assets/images/lorr-headshot-illo.png";
import michaelHeadshot from "assets/images/michael-littig-headshot-illo.png";
import zachHeadshot from "assets/images/zach-fedor-headshot-illo.png";

function About() {
  return (
    <Main>
      <Head title="About Us" />

      <SiteContainer>
        <header>
          <SH1 aria-label="About Us">
            <img src={aboutUsSVG} alt="" aria-hidden="true" />
          </SH1>
          <InclusiverseImg
            src={welcomeInclusiverseSVG}
            alt=""
            aria-hidden="true"
          />
        </header>
        <Article>
          <Intro>
            <Text size="md">
              Founded by <Link to="#randi">Randi Zuckerberg</Link> and{" "}
              <Link to="#debbie">Debbie Soon</Link>, HUG is committed to
              embracing Web3 creators and building a more diverse and inclusive
              ecosystem, or as we like to call it: the inclusiverse.
            </Text>

            <Text size="md">
              We do this through a community review platform that helps people
              discover new NFT projects in a thoughtfully-curated way, as well
              as a number of educational and mentorship programs we have
              designed especially for creators.
            </Text>

            <Text size="md">
              Our joyful tools and programs are created for creators, by
              creators. We’re excited to help build the inclusiverse and welcome
              experts and newcomers alike — while giving plenty of hugs along
              the way!
            </Text>

            <Text size="md">
              Find us <Link href={constants.twitterURL}>@thehugxyz</Link> on
              Twitter.
            </Text>
          </Intro>
          <Hr />

          <Founder alignItems="flex-start" flexWrap="wrap" id="randi">
            <figure>
              <Headshot
                src={randiHeadshot}
                alt="Black and white photograph of Randi Zuckerburg smiling"
              />
              <SIconMicrophone aria-hidden="true" />
              <SIconClouds aria-hidden="true" />

              <FounderAvatars>
                <Avatar src={randiAvatar1} alt="" aria-hidden="true" />
                <Avatar src={randiAvatar2} alt="" aria-hidden="true" />
                <Avatar src={randiAvatar3} alt="" aria-hidden="true" />
              </FounderAvatars>
            </figure>

            <div>
              <TwitterLink href="https://twitter.com/randizuckerberg">
                Randi Zuckerberg
              </TwitterLink>
              <Subtitle>Founder</Subtitle>
              <Text>
                Randi has always loved technology and the arts. As a Harvard
                graduate and early employee at Facebook, she helped shape Web
                2.0 technology for billions of people worldwide. She also
                performed on Broadway in Rock of Ages, won three Tony awards for
                producing Hadestown, Oklahoma!, and The Inhertitance, and
                produced the first-ever simulcast run of a commercial Broadway
                show during the height of COVID.
              </Text>
              <Text>
                Now in Web3, she&apos;s bringing her two loves together. Randi
                is one of the most prominent voices for women in the NFT space
                and is passionate about uplifting creators — that&apos;s why she
                founded HUG! She now gets to advise and work with some of the
                best crypto companies, including Boss Beauties, BFF, Women Rise,
                OKCoin, and Republic.
              </Text>
              <Text>
                When she&apos;s not trading jpegs, she can be found at the
                theater or doing her best to unplug at home with her husband and
                three children who are now almost as obsessed with crypto as she
                is.
              </Text>
            </div>
          </Founder>

          <Founder alignItems="flex-start" flexWrap="wrap" id="debbie">
            <figure>
              <Headshot
                src={debbieHeadshot}
                alt="Black and white photograph of Debbie Soon smiling and looking upwards"
              />
              <SIconBarbell aria-hidden="true" />
              <SIconHearts aria-hidden="true" />

              <FounderAvatars>
                <Avatar src={debbieAvatar1} alt="" aria-hidden="true" />
                <Avatar src={debbieAvatar2} alt="" aria-hidden="true" />
                <Avatar src={debbieAvatar3} alt="" aria-hidden="true" />
              </FounderAvatars>
            </figure>

            <div>
              <TwitterLink href="https://twitter.com/debsoon">
                Debbie Soon
              </TwitterLink>
              <Subtitle>Co-Founder</Subtitle>

              <Text>
                Debbie is a Chinese-Singaporean immigrant who is passionate
                about increasing representation in Web3. Having spent her entire
                career both investing in and building multimillion-dollar
                consumer businesses, she&apos;s particularly excited about the
                intersection of Web3 and consumer. Now, she&apos;s the
                co-founder of HUG, where she&apos;s helping build a space for
                people to collaborate, connect, and interact with each other.
              </Text>
              <Text>
                Prior to Web3, Debbie graduated from the University of Cambridge
                with a degree in Economics and from Columbia University with a
                Masters in Financial Engineering. Then, she was an equity
                investor where she managed over $1 billion of global consumer
                sector investments for one of the largest sovereign wealth funds
                in the world, GIC. From there, she pivoted into the world of
                startups where she founded Singapore and Southeast Asia&apos;s
                first boutique indoor cycling studio. She then went on to build
                three businesses from scratch for one of the most successful
                unicorns in Southeast Asia, Sequoia Capital-backed ONE
                Championship.
              </Text>
              <Text>
                Outside of helping break down barriers for equitable
                representation, she enjoys lifting weights, car karaoke, and
                pampering her 10-year-old dog, Guinness.
              </Text>
            </div>
          </Founder>
          <Hr />
          <TeamMemberGrid
            alignItems="flex-start"
            flexWrap="wrap"
            itemsFlex="1 1 200px"
          >
            <TeamMember>
              <Headshot src={loriHeadshot} alt="Headshot of Lori Grace" />
              <div>
                <TwitterLink href="https://twitter.com/lorigraceaz">
                  Lori Grace
                </TwitterLink>
                <Subtitle>DEI Advisor</Subtitle>
              </div>

              <Text>
                Lori Grace Bailey is a Hispanic trans woman who dedicates much
                of her time to supporting and onboarding women, LGBTQIA+, and
                other marginalized groups into the NFT space through hosting Rug
                Radio&apos;s &ldquo;Elevating Women in NFT&rdquo; Twitter
                Spaces. She is also a dedicated NFT artist and photographer
                whose work features extreme weather and extraordinary skies.
                Lori is also a founding member of other like-minded Web3
                communities BFF and Nvak Collective.
              </Text>
            </TeamMember>
            <TeamMember>
              <Headshot src={hansHeadshot} alt="Headshot of Dr. Hans Boateng" />
              <div>
                <TwitterLink href="https://twitter.com/investingtutor">
                  Dr. Hans Boateng
                </TwitterLink>
                <Subtitle>DEI Advisor</Subtitle>
              </div>

              <Text>
                Dr. Hans Boateng is the founder of The Investing Tutor and The
                Royals NFT, the winner of the Diversity Award at NFT NYC 2022.
                He has a deep passion for helping his community build
                generational wealth. This led him to create the first investment
                tutoring business in the US and the first major travel NFT to
                showcase and celebrate African culture. His vision is to create
                a Royal Family that travels the world, and brings different
                cultures together to build a more inclusive Web3.
              </Text>
            </TeamMember>

            <TeamMember>
              <Headshot src={chrisHeadshot} alt="Headshot of Chris Kelly" />
              <div>
                <TwitterLink href="https://twitter.com/thatchriskelly">
                  Chris Kelly
                </TwitterLink>
                <Subtitle>Board Member and Advisor</Subtitle>
              </div>

              <Text>
                Chris Kelly is the co-owner of NBA team the Sacramento Kings and
                an investor at Alchemy, the leading development tool for
                Ethereum, Flow, and other blockchains. He was previously Chief
                Privacy Officer, first General Counsel, and Head of Global
                Public Policy at Facebook. Aside from being an active angel
                investor in tech companies, Chris is also a huge supporter of
                the arts, having produced a number of independent films
                including award-winning documentary Jiro Dreams of Sushi.
              </Text>
            </TeamMember>
          </TeamMemberGrid>

          <Hr />

          <SH2>MEET OUR TEAM</SH2>

          <MeetOurTeam
            src={meetOurTeam}
            alt="Illustration of the HUG team in the inclusiverse with our favorite projects"
          />

          <TeamGrid>
            <div>
              <Img
                src={amyHeadshot}
                width="80"
                height="80"
                alt="Headshot of Amy McMillen"
              />
              <TwitterLink href="https://twitter.com/amymcmai">
                Amy McMillen
              </TwitterLink>
              <Subtitle>Project Manager</Subtitle>
            </div>

            <div>
              <Img
                src={brianHeadshot}
                width="80"
                height="80"
                alt="Headshot of Brian Murphy"
              />
              <TwitterLink href="https://twitter.com/B_P_Murphy">
                Brian Murphy
              </TwitterLink>
              <Subtitle>Creator Success Manager</Subtitle>
            </div>

            <div>
              <Img
                src={davednoHeadshot}
                width="80"
                height="80"
                alt="Headshot of David Diienno"
              />
              <TwitterLink href="https://twitter.com/_davedno">
                David Diienno
              </TwitterLink>
              <Subtitle>Developer</Subtitle>
            </div>

            <div>
              <Img
                src={juliaHeadshot}
                width="80"
                height="80"
                alt="Headshot of Julia Gierasimow"
              />
              <TwitterLink href="https://twitter.com/juliagierasimow">
                Julia Gierasimow
              </TwitterLink>
              <Subtitle>Admin</Subtitle>
            </div>

            <div>
              <Img
                src={kenHeadshot}
                width="80"
                height="80"
                alt="Headshot of Ken Richard"
              />
              <TwitterLink href="https://twitter.com/Kenr000">
                Ken Richard
              </TwitterLink>
              <Subtitle>Head of Engineering</Subtitle>
            </div>

            <div>
              <Img
                src={lorrHeadshot}
                width="80"
                height="80"
                alt="Headshot of Lorraine Ye"
              />
              <TwitterLink href="https://twitter.com/lorrNFT">
                Lorraine Ye
              </TwitterLink>
              <Subtitle>Head Curator</Subtitle>
            </div>

            <div>
              <Img
                src={michaelHeadshot}
                width="80"
                height="80"
                alt="Headshot of Michael Littig"
              />
              <TwitterLink href="https://twitter.com/Michael_Littig">
                Michael Littig
              </TwitterLink>
              <Subtitle>Director of Creator Programming</Subtitle>
            </div>

            <div>
              <Img
                src={zachHeadshot}
                width="80"
                height="80"
                alt="Headshot of Zach Fedor"
              />
              <TwitterLink href="https://twitter.com/zachfedor">
                Zach Fedor
              </TwitterLink>
              <Subtitle>Developer</Subtitle>
            </div>
          </TeamGrid>

          <SText>
            Art by{" "}
            <Link href="https://twitter.com/eislyn_eth">@eislyn_eth</Link>
          </SText>
        </Article>
      </SiteContainer>
    </Main>
  );
}

const Main = styled.main(({ theme }) => ({
  backgroundColor: theme.colors.pink,
  backgroundImage: theme.gradients.radial5,
}));

const Article = styled.article({
  padding: "1rem",
  margin: "0 auto",
  maxWidth: "calc(1140px + 6rem)",
  "@media (min-width: 480px)": {
    padding: "1rem 2rem",
  },
  "@media (min-width: 768px)": {
    padding: "1rem 3rem",
  },
  figure: {
    margin: 0,
    position: "relative",
  },
});

const Intro = styled.div({
  margin: "0 auto 5rem",
  maxWidth: "800px",
  "p + p": {
    marginTop: "2rem",
  },
});

const SH1 = styled(H1)({
  textAlign: "center",
  img: {
    margin: "0 1rem 2rem",
    width: "90%",
    maxWidth: "600px",
  },
});

const Headshot = styled(Img)(({ theme }) => ({
  borderRadius: theme.borderRadius.md,
}));

const Founder = styled(FlexRow)({
  gap: "3rem",
  margin: "5rem 0",
  figure: {
    flex: "1 1 200px",
    maxWidth: "300px",
    position: "relative",
    margin: "0 auto",
  },
  h2: {
    textAlign: "center",
  },
  "& > div": {
    flex: "0 0 100%",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  "@media (min-width: 800px)": {
    gap: "3rem",
    figure: {
      flex: "1",
      maxWidth: "none",
    },
    h2: {
      textAlign: "left",
    },
    "& > div": {
      alignItems: "flex-start",
      flex: "2",
    },
  },
});

const FounderAvatars = styled(FlexRow)({
  marginTop: "1rem",
  justifyContent: "space-between",
  img: {
    height: "100%",
  },
});

function TwitterLink({
  href,
  children,
  ...props
}: {
  href: string;
  children: React.ReactNode;
}) {
  return (
    <TwitterLinkWrapper href={href} {...props}>
      <H2>{children}</H2>
      <IconTwitter />
    </TwitterLinkWrapper>
  );
}

const TwitterLinkWrapper = styled(Link)(({ theme }) => ({
  alignItems: "center",
  display: "flex",
  justifyContent: "flex-start",
  marginBottom: "0.25rem",
  textDecoration: "none",
  width: "fit-content",
  h2: {
    margin: 0,
  },
  svg: {
    fontSize: theme.fontSizes.h3,
    marginLeft: "1rem",
  },
}));

const Subtitle = styled(Text)(({ theme }) => ({
  fontWeight: "bold",
  lineHeight: "1.2",
  marginBottom: "1.5rem",
  marginTop: "1rem !important",
}));

const TeamMemberGrid = styled(FlexRow)({
  gap: "3rem 2rem",
  padding: "3rem 0",
  "@media (min-width: 801px)": {
    "&>*": {
      maxWidth: "calc(50% - 1rem)",
    },
  },
});

const TeamMember = styled.div({
  "&>div": {
    margin: "1rem 0 0",
  },
  "@media (max-width: 800px)": {
    alignItems: "center",
    flex: "0 0 100% !important",
    display: "flex",
    flexWrap: "wrap",
    gap: "10px 1rem",
    img: {
      alignSelf: "flex-start",
      flex: "1",
      width: "calc(40% - 10vw)",
      maxWidth: "150px",
      marginBottom: "1rem",
    },
    "&>div": {
      flex: "1 0 50%",
      margin: 0,
      marginBottom: "1rem",
    },
    p: {
      flex: "0 0 100%",
    },
  },
});

const SH2 = styled(H2)(({ theme }) => ({
  fontSize: theme.fontSizes.h1,
  margin: "3rem 0 2rem",
  textAlign: "center",
}));

const MeetOurTeam = styled.img(({ theme }) => ({
  gap: "3rem 10px",
  borderRadius: theme.borderRadius.lg,
  display: "block",
  margin: "1rem auto",
  maxWidth: 800,
  width: "100%",
}));

const TeamGrid = styled(Grid)(({ theme }) => ({
  gap: "3rem 10px",
  padding: "2rem 0",
  "@media (max-width: 399px)": {
    gridTemplateColumns: "1fr",
  },
  h2: {
    fontSize: theme.fontSizes.lg,
  },
  svg: {
    marginLeft: "0.8rem",
  },
  small: {
    display: "block",
    fontSize: theme.fontSizes.sm,
  },
  "&>div": {
    alignItems: "center",
    display: "flex",
    "@media (min-width: 400px)": {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  img: {
    marginBottom: "1rem",
    maxWidth: "100%",
    width: "auto",
  },
}));

const SText = styled(Text)({
  marginBottom: "3rem",
  textAlign: "center",
  textUnderlineOffset: "2px",
});

const InclusiverseImg = styled.img(({ theme }) => ({
  display: "none",
  "@media (min-width: 1100px)": {
    display: "block",
    border: `2px solid ${theme.colors.fg}`,
    borderRadius: theme.borderRadius.round,
    position: "absolute",
    top: "8rem",
    right: 0,
    transform: "rotate(15deg) scale(0.7)",
  },
}));

const SIconMicrophone = styled(IconMicrophone)({
  position: "absolute",
  top: "5%",
  left: 0,
  transform: "translate(-45%, 20%) scale(.75)",
  "@media (min-width: 800px)": {
    transform: "translate(-55%, 20%) scale(.66)",
  },
  "@media (min-width: 1140px)": {
    transform: "translate(-66%, 20%)",
  },
});

const SIconClouds = styled(IconClouds)({
  position: "absolute",
  bottom: 0,
  right: 0,
  transform: "translate(45%, -55%) scale(.75)",
  "@media (min-width: 800px)": {
    transform: "translate(35%, -40%) scale(.66)",
  },
  "@media (min-width: 1140px)": {
    transform: "translate(21%, -75%)",
  },
});

const SIconBarbell = styled(IconBarbell)({
  position: "absolute",
  top: "20%",
  right: 0,
  transform: "translate(35%, -60%) scale(.75)",
  "@media (min-width: 800px)": {
    transform: "translate(35%, -60%) scale(.66)",
  },
  "@media (min-width: 1140px)": {
    transform: "translate(35%, -80%)",
  },
});

const SIconHearts = styled(IconHearts)({
  position: "absolute",
  bottom: 0,
  left: 0,
  transform: "translate(-75%, 10%) scale(.75)",
  "@media (min-width: 800px)": {
    transform: "translate(-55%, 50%) scale(.66)",
  },
  "@media (min-width: 1140px)": {
    transform: "translate(-53%, 53%)",
  },
});

export { About };
